import { useState, useEffect, useRef } from 'react';
import useStore from '../../../store';

export const useMafiaTimer = (game, mafia, activeTab) => {
  useStore(state => state.render);

  const store = useStore.getState();

  const [timeLeft, setTimeLeft] = useState(0);
  const [isMenuLocked, setIsMenuLocked] = useState(false);
  const [countdownValue, setCountdownValue] = useState(null);
  const [isCountdownDanger, setIsCountdownDanger] = useState(true);

  // Ref, чтобы не спамить открытием меню каждый тик
  const autoOpenTriggered = useRef(false);

  useEffect(() => {
    if (game?.mode !== 'mafia') return;

    // ИЗМЕНЕНИЕ: Определяем subMode
    const subMode = game?.subMode;

    // Сбрасываем триггер при смене фазы
    autoOpenTriggered.current = false;

    const interval = setInterval(() => {
      const serverTime = store.ref.info.methods.serverTimeFun();

      const delta = Math.ceil((mafia.endTime - serverTime) / 1000);
      const safeTimeLeft = delta > 0 ? delta : 0;

      setTimeLeft(safeTimeLeft);

      // --- ЛОГИКА НОЧИ (ПРЕДУПРЕЖДЕНИЯ ДЛЯ АКТИВНЫХ РОЛЕЙ) ---
      // ИЗМЕНЕНИЕ: Добавляем проверку subMode === 'mafia'
      if (mafia.phase === 'night' && (mafia.role === 'mafia' || mafia.role === 'doctor')) {
          const nightState = mafia.nightState || {};
          const myActions = nightState.myActions || {};
          const mafiaState = nightState.mafiaState || {};

          // Проверка: сделал ли я действие?
          // Мафия: есть ли хоть один голос в команде. Доктор: есть ли хил.
          let iHaveActed = false;
          if (mafia.role === 'mafia') {
              iHaveActed = Object.keys(mafiaState.shootVotes || {}).length > 0;
          } else {
              iHaveActed = !!myActions['heal'];
          }

          // 1. ПРЕДУПРЕЖДЕНИЕ (15 сек): Открываем меню действий, если забыл
          if (!autoOpenTriggered.current && safeTimeLeft <= 15 && safeTimeLeft > 5) {
              if (!iHaveActed && activeTab !== 'action') {
                  autoOpenTriggered.current = true;
                  mafia.methods.setActiveTab('action');
              }
          }

          // 2. ОПАСНОСТЬ (5 сек): Обратный отсчет на весь экран
          if (safeTimeLeft <= 5 && safeTimeLeft > 0) {
              setCountdownValue(prev => prev !== safeTimeLeft ? safeTimeLeft : prev);

              // Если не походил - красный цвет, иначе - нейтральный
              setIsCountdownDanger(!iHaveActed);

              if (!iHaveActed) {
                  // Если критично - блокируем выход из меню
                  if (activeTab !== 'action') mafia.methods.setActiveTab('action');
                  setIsMenuLocked(true);
              } else {
                  setIsMenuLocked(false);
              }
          } else {
              setCountdownValue(null);
              setIsMenuLocked(false);
          }
      }
      
      else if (subMode !== 'mafia' && mafia.team === 'mafia' && mafia.phase === 'draw_mafia') {

        setIsMenuLocked(false);
        // Показываем отсчет последние 5 секунд, но не "опасный" (белый)
        if (safeTimeLeft <= 5 && safeTimeLeft > 0) {
            setCountdownValue(prev => prev !== safeTimeLeft ? safeTimeLeft : prev);
            setIsCountdownDanger(false);
        } else {
            setCountdownValue(null);
        }

      }
      // --- ЛОГИКА ДЛЯ МИРНЫХ (РИСОВАНИЕ) ---
      else if (mafia.team === 'town' && mafia.phase === 'draw_civilian') {
        setIsMenuLocked(false);
        // Показываем отсчет последние 5 секунд, но не "опасный" (белый)
        if (safeTimeLeft <= 5 && safeTimeLeft > 0) {
            setCountdownValue(prev => prev !== safeTimeLeft ? safeTimeLeft : prev);
            setIsCountdownDanger(false);
        } else {
            setCountdownValue(null);
        }
    }
      // --- ОСТАЛЬНЫЕ ФАЗЫ ---
      else {
          setIsMenuLocked(false);
          setCountdownValue(null);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [
    game?.mode,
    game?.subMode, // ИЗМЕНЕНИЕ: Добавляем subMode в зависимости
    mafia.endTime,
    mafia.role,
    mafia.phase,
    mafia.nightState, // Важно: реагируем на обновление стейта ночи
    activeTab,
    mafia.methods // Для вызова setActiveTab
  ]);

  return {
    timeLeft,
    isMenuLocked,
    countdownValue,
    isCountdownDanger
  };
};